import api from './api';

export const guestViewingSlotsAPI = {
  list: (inquiryId) => api.get(`/bookings/inquiry/${inquiryId}/viewing-slots`),
  reserve: (inquiryId, slotId) =>
    api.post(`/bookings/inquiry/${inquiryId}/viewing-slots/${slotId}/reserve`),
};
